'use client'
import React,{useState} from 'react';
import EmployAside from '../../aside';
import ModifierFacture from './ModifierFacture';

const EmployDashboardProfilePage = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (
    
    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <ModifierFacture setIsOpenSidebar={setIsOpenSidebar}/>
    </div>   
  );
};

export default EmployDashboardProfilePage;